import React from 'react';

import ModelTypeConstants from 'constants/ModelTypeConstants';
import TemplateCollectionDAO from 'notebook/entry-templates/collections/TemplateCollectionDAO';
import EmptySidebarIcon from 'sidebar/EmptySidebarIcon';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {Section} from './SidebarConstants';
import SidebarItem from './SidebarItem';

export interface TemplateCollectionType {
  name: string;
  url: string;
}

export interface TemplateCollectionsSettingsProps {
  section: Section;
  template?: {
    templateCollection?: TemplateCollectionType;
  };
  templateCollection?: TemplateCollectionType;
}

function getBreadcrumbCollection(
  props: TemplateCollectionsSettingsProps
): TemplateCollectionType | null | undefined {
  switch (props.section) {
    case Section.NOTEBOOK_SETTINGS_TEMPLATE:
      return props.template != null ? props.template.templateCollection : undefined;
    case Section.NOTEBOOK_SETTINGS_TEMPLATE_COLLECTION:
      return props.templateCollection;
    default:
      return null;
  }
}

function TemplateCollectionsSidebarItem({
  section,
}: {
  section: TemplateCollectionsSettingsProps['section'];
}): JSX.Element | null {
  return (
    <SidebarItem
      active={section === Section.NOTEBOOK_SETTINGS_TEMPLATE_COLLECTIONS}
      icon={React.createElement(BenchlingIcon, {
        className: 'result-icon',
        icon: ModelTypeConstants.TEMPLATE_COLLECTION,
      })}
      name="Template collections"
      link={TemplateCollectionDAO.collectionsURL()}
    />
  );
}

function TemplateCollectionSidebarItem({
  props,
}: {
  props: TemplateCollectionsSettingsProps;
}): JSX.Element | null {
  const breadcrumbCollection = getBreadcrumbCollection(props);
  if (breadcrumbCollection != null) {
    return (
      <SidebarItem
        active={props.section === Section.NOTEBOOK_SETTINGS_TEMPLATE_COLLECTION}
        icon={<EmptySidebarIcon />}
        name={breadcrumbCollection.name}
        link={breadcrumbCollection.url}
      />
    );
  }
  return null;
}

export default function TemplateCollectionsSettings(props: TemplateCollectionsSettingsProps): JSX.Element {
  return (
    <div className="u-spacing-top">
      <div className="browser-nav-header">Template Collections</div>
      <TemplateCollectionsSidebarItem section={props.section} />
      <TemplateCollectionSidebarItem props={props} />
    </div>
  );
}
